import { useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';

const SubscriptionCancelPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnPath = searchParams.get('returnPath') || '/';

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(returnPath);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, returnPath]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="text-center p-8"
      >
        <div className="mb-6 text-6xl">💭</div>
        <h1 className="text-2xl font-bold mb-4">Taking You Back</h1>
        <p className="text-gray-600 mb-8">
          No problem! You can upgrade to premium whenever you're ready.
        </p>
      </motion.div>
    </div>
  );
};

export default SubscriptionCancelPage;
